import { NumberingElementKeyOption, NumberingPluginOptionsValues } from './types';

export const ELEMENT_NUMBERING = 'numberingElement';

export const DEFAULT_NUMBERING: Record<
  NumberingElementKeyOption,
  Required<NumberingPluginOptionsValues>
> = {
  numberingElement: {
    component: null,
    type: ELEMENT_NUMBERING,
    rootProps: {
      className: 'slate-numbering-element',
    },
    hotkey: '',
    defaultType: '',
  },
};
